import * as Yup from 'yup'

export const cieloMerchantSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Minimo 3 caracteres')
    .max(128, 'Máximo 128 caracteres')
    .required('Insira o nome'),
  merchant_id: Yup.string()
    .max(64, 'Máximo 64 caracteres')
    .required('Insira o Merchant ID'),
  merchant_key: Yup.string()
    .max(64, 'Máximo 64 caracteres')
    .required('Insira a Merchant Key'),
  ec: Yup.string()
    .max(64, 'Máximo 64 caracteres'),
  expiration_at: Yup.string().nullable(),
});
